import React from "react";
import "./assets/scss/variables/fontFamily.scss";
import "./assets/scss/global/global.scss";
import "./assets/icons/edel_icons/style.scss";
import { REdRouter } from "./routing/REdRouter";

const App = () => {
	return (
		<>
			<REdRouter />
		</>
	);
};

export default App;
